import { Instance } from 'mobx-state-tree';
import { EngineActionDtoModelBase } from './EngineActionDtoModel.base';

/* The TypeScript type of an instance of EngineActionDtoModel */
export interface EngineActionDtoModelType extends Instance<typeof EngineActionDtoModel.Type> {}

/* A graphql query fragment builders for EngineActionDtoModel */
export { selectFromEngineActionDto, engineActionDtoModelPrimitives, EngineActionDtoModelSelector } from './EngineActionDtoModel.base';

/**
 * EngineActionDtoModel
 */
export const EngineActionDtoModel = EngineActionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
